//resources/assets/js/vuex/utils/api.js

import axios from 'axios'


import store from './index';
import router from '../routes/index';


const ax = axios.create({
	// baseURL: 'http://127.0.0.1:8000/',
	// baseURL: 'https://buffalo.wageup.com/'
	baseURL: 'https://ace-dashboard-api.wageup.com/'
});

function checkForToken() {
	if (localStorage.access) return localStorage.access
}

function updateToken() {
	let refresh_token = localStorage.refresh;
	console.log("UPDATING TOKEN")
	return ax.post('/accounts/refresh/', {'refresh': refresh_token})
			.then(function (response) {
				let new_token = response.data.access
				localStorage.access = new_token;
				console.log("new token", new_token)
				ax.defaults.headers.common['Authorization'] = 'Bearer ' + new_token;
				return new_token
			}).catch((error) => {
				console.log("ERROR INFO", error)
				console.error("Refresh Token Expired. Logging out.")
				localStorage.refresh = 0;
				localStorage.access = 0;
				router.push('login');
			})
}


const token = checkForToken();

if (token) {
	ax.defaults.headers.common['Authorization'] = 'Bearer ' + token;
} else {
	updateToken();
}

ax.interceptors.request.use(function (config) {
		store.state.loading = true
		return config
	}
)

ax.interceptors.response.use(
		async (response) => {
			// store.dispatch('toggleLoad')
			store.state.loading = false
			return response
		},
		async (error) => {
			console.log(localStorage.refresh, "refresh token", typeof localStorage.refresh)
			console.log(localStorage.refresh === "0")
			if (error.response.status === 401) {
				console.log("ERROR 401")
				const originalRequest = error.config;
				let updatedResponse;
				await updateToken()
						.then((token) => {
							if (!token) throw new Error('updateToken method did not return an appropriate value');
							originalRequest.headers['Authorization'] = 'Bearer ' + token;
							return ax(originalRequest);
						})
						.then((response) => {
							updatedResponse  = response;
						})
						.catch((err) => {
							updatedResponse = err;
						})

				return updatedResponse ? Promise.resolve(updatedResponse) : Promise.reject(updatedResponse)
				.catch(() => {
						console.log("SECOND CATCH")
				}); //we've failed on two requests, so we must assume that the refresh token is expired. Force user to login again.
			} else if (error.response.status == 403) {
				// let store = JSON.parse(localStorage.getItem('store'));
				// let location_address = '/dashboard/' + store.user.data.organization.slug + '?forbidden=1';
				// router.replace(location_address);
				// router.go()
				// router.go(-1);
				store.dispatch('logout').then(() => router.push('/dashboard'));
			} else {
				store.state.loading = false;
				return Promise.reject(error)
			}

		});


export default {

	get(url, request) {
		if (!request) {
			request = {}
		}

		return ax.get(url, request)
				.then((response) => Promise.resolve(response.data))
				.catch((error) => Promise.reject(error));
	},

	post(url, request) {
		
		return ax.post(url, request)
				.then((response) => Promise.resolve(response))
				.catch((error) => Promise.reject(error));
	},

}
